import { defineEntity, object, string } from '~/prix'

const appSebraeAtendimentoEntity = defineEntity({
  key: 'atendimento',
  title: 'Atendimento App Sebrae',
  sources: ['olap', 'oltp'],
  schema: object({
    id: string().label('ID', 'Identificador', 'Codigo'),
    regional: string().isOptional().label('Regional'),
  }),
})

export default appSebraeAtendimentoEntity
